import React from 'react';
import { connect } from 'react-redux';
import { signOut } from '../../../actions';
import PersonIcon from '@material-ui/icons/Person';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import MenuIcon from '@material-ui/icons/Menu';
import Button from '@material-ui/core/Button';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

class Navbar extends React.Component{
    constructor(props) {
        super(props);
        this.state = { 
            anchorEl: null,
        }

        // This binding is necessary to make `this` work in the callback
        this.handleClickLogout = this.handleClickLogout.bind(this);
    }
    async handleClickLogout() {
        await this.props.signOut();
    }

    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget });
    };
    
    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    render(){
        const { anchorEl } = this.state;
        return (
            <nav className="navbar navbar-expand-lg navbar-light bg-light" style={{marginBottom: "30px"}}>
                <div className="container-fluid">
                    <button type="button" id="sidebarCollapse" className="btn btn-outline-dark btn-sm" aria-label="Menu navigasi" aria-controls="sidebar">
                        <MenuIcon />
                    </button>
                    <h4>{this.props.title}</h4>
                    {/* <Button id="logout" onClick={this.handleClick}><PersonIcon /> Logout</Button> */}
                    <div>
                        <Button
                        aria-owns={anchorEl ? 'simple-menu' : null}
                        aria-haspopup="true"
                        onClick={this.handleClick}
                        >
                            {this.props.account.namaUser} &nbsp; <ArrowDropDownIcon />
                        </Button>
                        <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={this.handleClose}
                        >
                        <MenuItem onClick={this.handleClickLogout}><ExitToAppIcon />&nbsp; Logout</MenuItem>
                        </Menu>
                    </div>
                </div>
            </nav>
        );        
    }
}

const mapStateToProps = (state) => {
    return{
        account: state.account
    };
}
export default connect(mapStateToProps, {signOut})(Navbar);
